import { Octokit } from "octokit";

export const octokit = new Octokit();